mutation UnpublishBimClassRevision (
    $id: ID!
    $revisionID: ID!
) {
    untagBimClass(
        id: $id
        revisionID: $revisionID
        tag: "public"
    )
}
